module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stream-browserify/~/readable-stream/passthrough.js
// module id = 427
// module chunks = 2